import React, { useMemo } from 'react';
import { formatCompactNumber, formatValue } from '../Meta/metaUtils';

export default function ProgressStatCard({ items = [], theme = {}, rows, dataContext }) {
    const {
        colors = ['#ef4444', '#6366f1', '#10b981', '#06b6d4', '#7c3aed', '#6b7280', '#f59e0b', '#22c55e'],
        trackColor = 'rgba(148, 163, 184, 0.25)',
        valueFormat = 'currency',
        valuePrefix = '$',
        maxItems = 8,
    } = theme || {};

    const limitedItems = useMemo(() => Array.isArray(items) ? items.slice(0, maxItems) : [], [items, maxItems]);

    const itemSkipConfig = dataContext?.props?.items?.skip;
    const maxValueKey = dataContext?.props?.items?.maxValue;
    const valueKey = dataContext?.props?.items?.value;
    const labelKey = dataContext?.props?.items?.label;

    return (
        <div className="flex flex-col gap-4">
            <div className="flex-grow overflow-y-auto max-h-[340px] pr-2">
                {limitedItems.map((item, idx) => {
                    const color = item?.color || colors[idx % colors.length];
                    const label = rows[idx][labelKey];
                    const maxValue = rows[idx][maxValueKey];
                    const value = Number(rows[idx][valueKey] ?? 0);
                    const pct = maxValue > 0 ? Math.max(0, Math.min(100, (value / maxValue) * 100)) : 0;

                    const hasOverSpending = value > maxValue;


                    if (itemSkipConfig?.key && itemSkipConfig?.values?.includes(label)) return null;

                    return (
                        <div key={`${label ?? idx}`} className="flex items-center gap-4 py-3">
                            <div className="w-20 shrink-0 text-gray-600 text-[15px] font-medium">
                                {label}
                            </div>
                            <div className="w-32">
                                <div className="has-tooltip h-2 rounded-full" style={{ backgroundColor: trackColor }}>
                                    <div className="h-2 rounded-full" style={{ width: `${pct}%`, backgroundColor: color }} />

                                    <div
                                        className={`tooltip w-max p-2 rounded-xl m-[1px] px-2 py-2`}
                                        style={{ backgroundColor: color + '30' }}
                                    >
                                        {formatValue(value, valueFormat, { prefix: valuePrefix, suffix: '', maximumFractionDigits: 0 })}
                                    </div>
                                </div>
                            </div>
                            <div className={`has-tooltip`}>
                                <div className={`shrink-0 text-right font-medium ${hasOverSpending ? "text-[#EF7159]" : "text-[#989898]"} text-sm`}>
                                    {valuePrefix}
                                    {formatCompactNumber(value)}
                                    {"/"}
                                    {formatCompactNumber(maxValue)}
                                </div>
                                <div
                                    className={`tooltip w-max p-2 rounded-xl m-[1px] px-2 py-2`}
                                    style={{
                                        backgroundColor: "#ffffff",
                                        // left: "-50%",
                                        transform: "translateX(-50%)",
                                    }}
                                >
                                    {formatValue(value, valueFormat, { prefix: valuePrefix, suffix: '', maximumFractionDigits: 0 })}
                                    {" / "}
                                    {formatValue(maxValue, valueFormat, { prefix: "", suffix: '', maximumFractionDigits: 0 })}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}


